export const ASSETS_S3 = 'https://d32nutn1062dcr.cloudfront.net'
